import { BrowserIcon, DangerIcon, DiplomaIcon } from 'assets/icons'
import { useEffect } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { ClientRoute } from 'routes/client'
import { useAppDispatch } from 'store'
import { selectAuth } from 'store/authentication/slice'
import { getConfiguration } from 'store/authentication/thunks'
import styled from 'styled-components'

export default function Home(): JSX.Element {
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const { siteConfig } = useSelector(selectAuth)

  useEffect(() => {
    if (!siteConfig) {
      dispatch(getConfiguration())
    }
  }, [])
  const cardData = [
    {
      icon: <DiplomaIcon />,
      text: <FormattedMessage id="courseEditor.courseData" values={{ b: (chunks) => <b>{chunks}</b> }} />,
    },
    {
      icon: <BrowserIcon />,
      text: (
        <FormattedMessage
          id="courseEditor.recommendedBrowsers"
          values={{
            chrome: <a href="https://www.google.com/chrome/">Chrome</a>,
            firefox: <a href="https://www.mozilla.org/en-US/firefox/new/">Firefox</a>,
          }}
        />
      ),
    },
    {
      icon: <DangerIcon />,
      text: <FormattedMessage id="courseEditor.editingNotAvailable" values={{ b: (chunks) => <b>{chunks}</b> }} />,
    },
    {
      icon: <DangerIcon />,
      text: <FormattedMessage id="courseEditor.sections" values={{ b: (chunks) => <b>{chunks}</b> }} />,
    },
  ]

  return (
    <Container>
      <Title>{intl.formatMessage({ id: 'courseEditor.welcomeTitle' })}</Title>
      <SubTitle>{intl.formatMessage({ id: 'courseEditor.welcomeSubTitle' })}</SubTitle>
      <BetaButton>{intl.formatMessage({ id: 'strings.beta' })}</BetaButton>
      {cardData.map((card, index) => (
        <StyledCard key={index}>
          <CardContentContainer>
            {card.icon}
            <p>{card.text}</p>
          </CardContentContainer>
        </StyledCard>
      ))}
      <ContinueButton to={ClientRoute.COURSE_EDITOR_COURSE_SEARCH}>
        {intl.formatMessage({ id: 'strings.continue' })}
      </ContinueButton>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${(props) => props.theme.customPalette.darkGreen};
  max-width: 624px;
  width: 100%;
  row-gap: 16px;
  padding: 50px 0;
`

const Title = styled.h1`
  text-align: center;
  font-size: 44px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
`

const SubTitle = styled.h2`
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 135%;
  text-align: center;
  max-width: 484px;
`

const StyledCard = styled.div`
  max-width: 538px;
  min-height: 99px;
  border-radius: 8px;
  border: 1px solid #d1d8db;
  display: flex;
  align-items: center;
`

const CardContentContainer = styled.div`
  display: flex;
  padding: 24px;
  gap: 20px;
  align-items: center;

  > svg {
    width: 44px;
    height: 44px;
  }

  > p {
    line-height: 150%;
    max-width: 420px;

    > a {
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      text-decoration-line: underline;
      color: ${(props) => props.theme.palette.primary.main};
    }

    > b {
      font-weight: 600;
    }
  }
`

const BetaButton = styled.div`
  align-items: center;
  background: #3891ff;
  border-radius: 22px;
  color: #fff;
  display: inline-flex;
  font-size: 16px;
  font-weight: 400;
  gap: 10px;
  justify-content: center;
  padding: 10px 24px;
`

const ContinueButton = styled(Link)`
  align-items: center;
  background-color: ${(props) => props.theme.palette.primary.main};
  border-radius: 8px;
  color: ${(props) => props.theme.customPalette.light};
  display: flex;
  height: 53px;
  justify-content: center;
  margin-top: 50px;
  padding: 8px 24px;
  text-decoration: none;
  width: 242px;
`
